import { Card } from '@ksyos/design-system';
import type { ProviderService } from '../../../../interfaces/careProviderAddRightsState';
import { translateKey } from '../../../../../translate';
import { PreferredServiceOrganizationConsumers } from '../../../carePath/settings/components/PreferredServiceOrganizationConsumers';

interface IAddPreferredServiceConsumersProps {
    hasError: boolean;
    onChange: (preferredServiceConsumers: string[]) => void;
    providerService: ProviderService & {
        preferredServiceOrganizationConsumers?: string[];
    };
}

export function AddPreferredServiceConsumers(props: IAddPreferredServiceConsumersProps) {
    if (!props.providerService.settings.isServiceConsumerSelector) {
        return null;
    }

    return (
        <Card key={`preferredServiceConsumersFor${props.providerService.id}`}>
            <Card.Body>
                <PreferredServiceOrganizationConsumers
                    hasError={props.hasError}
                    onChange={props.onChange}
                    onDoValidate={() => {
                        return;
                    }}
                    selectedConsumerOrganizationIds={props.providerService.preferredServiceOrganizationConsumers ?? []}
                    service={props.providerService}
                    title={`${translateKey('carePath.requesterPreferenceList')} ${props.providerService.name}`}
                />
            </Card.Body>
        </Card>
    );
}
